interface PreviewArtifact {
  previewUrl?: string | null | undefined
  mediaType?: string | null | undefined
  contentType?: string | null | undefined
}

interface TaskPreviewMediaProps {
  artifact: PreviewArtifact
  alt: string
  className?: string
}

export function TaskPreviewMedia({ artifact, alt, className = '' }: TaskPreviewMediaProps) {
  if (!artifact.previewUrl) return null
  const video = artifact.mediaType === 'VIDEO' || artifact.contentType?.startsWith('video/')
  const classes = `task-preview-media${video ? ' is-video' : ''}${className ? ` ${className}` : ''}`

  return <div className={classes}>
    {video
      ? <video muted playsInline preload="metadata" src={artifact.previewUrl} aria-label={`${alt} 视频预览`} />
      : <img src={artifact.previewUrl} alt={alt} loading="lazy" />}
    {video && <span className="task-preview-video-badge" aria-hidden="true">▶</span>}
  </div>
}
